import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Backdrop, Modal, Slide } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import MainHostInfo from './components/MainInfo';
import FeedbackCard from './components/Feedback';
import ExtrasHost from './components/Extras';
import { IVanHost } from 'src/store/reducers/host/types';
import './styles.scss';

interface IProps {
  host: IVanHost;
  open: boolean;
  handleClose: () => void;
}

const HostModal: FC<IProps> = ({ open, handleClose, host }) => {
  const { first_name, feedback, description, host_tag } = host;

  return (
    <Modal open={open} onClose={handleClose} BackdropComponent={Backdrop} closeAfterTransition>
      <Slide direction='right' in={open} mountOnEnter unmountOnExit>
        <div className='right-float-modal modal' style={{ height: '100%' }}>
          <div className='hostModal'>
            <div className='hostModal__navigation'>
              <ArrowBackIosIcon onClick={handleClose} />
              <div className='hostModal__navigation__container'>
                <Link to={`/host/reviews/${host_tag[0]}`} target='_blank'>
                  Open in a new window
                  <OpenInNewIcon />
                </Link>
              </div>
            </div>
            <div className='hostModal__top'>
              <MainHostInfo host={host} />
              <div className='hostModal__top__description'>
                <h4>Hi, I am {first_name}</h4>
                <h6>Thanks for considering us for your next Sprinter Van Trip!</h6>
                <p>{description}</p>
                <div className='hostModal__top__description__info'>
                  <ExtrasHost />
                </div>
              </div>
            </div>
            {feedback.length ? (
              <h6 className='hostModal__review-title'>
                There are good things to talk about {first_name}
              </h6>
            ) : (
              <></>
            )}
            <div className='hostModal__review'>
              {feedback.map((el, i) => (
                <FeedbackCard feedback={el} key={i} />
              ))}
            </div>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};
export default HostModal;
